/**
 * Strips query string and hash from a URL, keeping origin + pathname, so
 *
 * @param {string} url
 * @returns {string}
 */
export function stripUrlQuery(url) {
  if (!url) return ''

  try {
    const parsed = new URL(url, window.location.origin)
    return `${parsed.origin}${parsed.pathname}`
  } catch {
    return String(url).split(/[?#]/)[0]
  }
}
